module.exports = __webpack_public_path__ + "images/f248124a193882db29d1dc5731bf3bc7.svg";